import { render, staticRenderFns } from "./ReviewDetail.vue?vue&type=template&id=85a16580&scoped=true&"
import script from "./ReviewDetail.vue?vue&type=script&lang=ts&"
export * from "./ReviewDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ReviewDetail.vue?vue&type=style&index=0&id=85a16580&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a16580",
  null
  
)

export default component.exports